export default __webpack_public_path__ + "static/media/files-o-tc.32483422.svg";